import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import CompanyTimeline from './components/CompanyTimeline';
import TeamSection from './components/TeamSection';
import SuccessStories from './components/SuccessStories';
import TrustIndicators from './components/TrustIndicators';
import VirtualOffice from './components/VirtualOffice';
import LegalInquirySection from './components/LegalInquirySection';
import Icon from '../../components/AppIcon';


const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>Über uns - AdvoCall Professional | ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH</title>
        <meta 
          name="description" 
          content="Lernen Sie AdvoCall Professional kennen - ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH. Erfahrene Rechtsanwälte, 24/7 Beratung und über 15 Jahre Expertise in Berlin." 
        />
        <meta name="keywords" content="AdvoCall, Rechtsanwälte Berlin, Rechtsberatung, Anwaltskanzlei, Telefonberatung, Rechtsfragen" />
        <meta property="og:title" content="Über AdvoCall Professional - Ihre Rechtsexperten" />
        <meta property="og:description" content="Rechtliche Expertise zugänglich gemacht. ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH mit über 15 Jahren Erfahrung. Stellen Sie uns Ihre Rechtsfrage." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/about-us" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <CompanyTimeline />
          <TeamSection />
          <SuccessStories />
          <TrustIndicators />
          <VirtualOffice />
          
          <LegalInquirySection />
        </main>

        {/* Footer */}
        <footer className="bg-text-primary text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              {/* Company Info */}
              <div className="md:col-span-2">
                <div className="flex items-center space-x-3 mb-6">
                  <img
                    src="/assets/images/Logo-Blue-and-white-use-on-black-1788636880205.png"
                    alt="AdvoCall Rechtsanwaltsgesellschaft Logo"
                    className="h-12 w-auto object-contain"
                  />
                </div>
                <p className="text-white/80 mb-6 max-w-md">
                  Rechtliche Expertise zugänglich gemacht - professionelle Rechtsberatung 
                  per Telefon, 24/7 verfügbar mit transparenten Preisen.
                </p>
                <div className="space-y-2">
                  <div className="flex items-center space-x-3">
                    <Icon name="MapPin" size={16} className="text-white/60" />
                    <span className="text-sm text-white/80">Kurfürstendamm 14, 10719 Berlin</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="Phone" size={16} className="text-white/60" />
                    <span className="text-sm text-white/80">09001000312</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="Mail" size={16} className="text-white/60" />
                    <span className="text-sm text-white/80">info@advocall.de</span>
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Schnellzugriff</h3>
                <ul className="space-y-2">
                  <li><a href="/homepage" className="text-white/80 hover:text-white transition-colors duration-200">Startseite</a></li>
                  <li><a href="/legal-areas-landing" className="text-white/80 hover:text-white transition-colors duration-200">Rechtsgebiete</a></li>
                  <li><a href="/for-lawyers" className="text-white/80 hover:text-white transition-colors duration-200">Für Anwälte</a></li>
                  <li><a href="/contact" className="text-white/80 hover:text-white transition-colors duration-200">Kontakt</a></li>
                  <li><a href="/trust-center" className="text-white/80 hover:text-white transition-colors duration-200">Bewertungen</a></li>
                </ul>
              </div>

              {/* Legal */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Rechtliches</h3>
                <ul className="space-y-2">
                  <li><a href="/legal-compliance" className="text-white/80 hover:text-white transition-colors duration-200">Datenschutz</a></li>
                  <li><a href="/legal-compliance" className="text-white/80 hover:text-white transition-colors duration-200">Impressum</a></li>
                  <li><a href="/legal-compliance" className="text-white/80 hover:text-white transition-colors duration-200">AGB</a></li>
                  <li><a href="/legal-compliance" className="text-white/80 hover:text-white transition-colors duration-200">Widerrufsrecht</a></li>
                </ul>
              </div>
            </div>

            <div className="border-t border-white/20 mt-12 pt-8 text-center">
              <p className="text-white/60 text-sm">
                © {new Date()?.getFullYear()} Advocall - ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH. Alle Rechte vorbehalten.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AboutUs;